import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TuiAlertService } from "@taiga-ui/core";
import { ClientService } from "../../core/services/client.service";
import { writeClientTypeConvertSession } from "../utils/client-type-conversion.storage";

@Injectable({ providedIn: "root" })
export class ClientTypeChangeFlowService {
  private readonly clientService = inject(ClientService);
  private readonly router = inject(Router);
  private readonly alerts = inject(TuiAlertService);

  execute(clientId: string, targetType: string) {
    return this.clientService.prepareClientTypeChange(clientId, targetType);
  }

  navigateToAddForm(res: { data: any }): void {
    const data = res?.data;
    if (!data?.prefill || !data?.archivedClientId) return;

    writeClientTypeConvertSession({
      prefill: data.prefill,
      targetType: data.targetType,
      archivedClientId: data.archivedClientId,
      archivedClientSummary: data.archivedClientSummary,
    });

    this.router.navigate(["/admin/client/add-edit"], {
      queryParams: { fromConversion: "1" },
    });
  }

  showError(message: string): void {
    this.alerts
      .open(message, { label: "Error", appearance: "error" })
      .subscribe();
  }

  showSuccess(message: string): void {
    this.alerts
      .open(message, { label: "Success", appearance: "success" })
      .subscribe();
  }
}
